/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: {
    horizontal: {
      description: 'Use horizontal to display timeline horizontally.',
      type: 'variant',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { horizontal: true, viewport: [ 'lg', 'xl' ] },
      tokens: {
        connectorHeight: 1,
        connectorWidth: '100%',
        itemContentMarginBottom: 0,
        itemContentMarginRight: 32,
        lineItemContainerDirection: 'column',
        lineItemDirection: 'row',
        lineItemMarginBottom: 24,
        lineItemMarginRight: 0,
        timelineContainerDirection: 'row'
      }
    }
  ],
  tokens: {
    connectorHeight: '100%',
    connectorWidth: 1,
    dotBorderWidth: 1,
    dotColor: '#ffffff',
    dotWidth: 14,
    itemContentFlexSize: 1,
    itemContentMarginBottom: 32,
    itemContentMarginRight: 0,
    lineContainerFlexSize: 1,
    lineItemAlign: 'center',
    lineItemContainerDirection: 'row',
    lineItemDirection: 'column',
    lineItemMarginBottom: 0,
    lineItemMarginRight: 24,
    timelineColor: '#676e73',
    timelineConnectorColor: '#676e73',
    timelineContainerDirection: 'column'
  }
}
export default theme
